import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { OpenInvoices } from '../../containers/reports/OpenInvoices';

export const AdminBillingOpenInvoicesPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<OpenInvoices />
		</AdminDashboardPageLayout>
	);
};
